"use strict";

var _ContainedLayout;
import { CarouselAssets } from '@autoguru/carousel-assets';
import { ContainedLayout } from '@autoguru/layout';
import { KiaOraIntroMobile } from '~/src/components/KiaOraIntro/KiaOraIntroMobile';
import { LearnMore } from '~/src/components/LearnMore/LearnMore';
import { makeLogosList } from '~/src/components/MakeLogosCarousel/makeLogos';
import { ManageAllFleetVehicles } from '~/src/components/ManageAllFleetVehicles/ManageAllFleetVehicles';
import { OnePortalUSP } from '~/src/components/OnePortalUSP/OnePortalUSP';
import { ServiceAllVehicles } from '~/src/components/ServiceAllVehicles/ServiceAllVehicles';
import { ServiceProvidersFeedback } from '~/src/components/ServiceProvidersFeedback/ServiceProvidersFeedback';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const LandingMobile = () => _ContainedLayout || (_ContainedLayout = /*#__PURE__*/_jsxs(ContainedLayout, {
  dropMargins: true,
  width: "bleed",
  children: [/*#__PURE__*/_jsx(ContainedLayout, {
    dropMargins: true,
    paddingTop: "7",
    paddingBottom: "5",
    children: /*#__PURE__*/_jsx(KiaOraIntroMobile, {})
  }), /*#__PURE__*/_jsx(ContainedLayout, {
    dropMargins: true,
    children: /*#__PURE__*/_jsx(ServiceAllVehicles, {
      size: "7"
    })
  }), /*#__PURE__*/_jsx(ContainedLayout, {
    dropMargins: true,
    width: "bleed",
    paddingY: "5",
    children: /*#__PURE__*/_jsx(CarouselAssets, {
      assetList: makeLogosList
    })
  }), /*#__PURE__*/_jsx(ContainedLayout, {
    dropMargins: true,
    children: /*#__PURE__*/_jsx(ManageAllFleetVehicles, {
      isDesktop: false
    })
  }), /*#__PURE__*/_jsx(ContainedLayout, {
    dropMargins: true,
    paddingTop: "7",
    paddingBottom: "5",
    paddingX: "5",
    children: /*#__PURE__*/_jsx(OnePortalUSP, {
      isDesktop: false,
      size: "7"
    })
  }), /*#__PURE__*/_jsx(ContainedLayout, {
    dropMargins: true,
    children: /*#__PURE__*/_jsx(ServiceProvidersFeedback, {
      isDesktop: false,
      size: "7"
    })
  }), /*#__PURE__*/_jsx(ContainedLayout, {
    dropMargins: true,
    paddingTop: "7",
    paddingBottom: "5",
    children: /*#__PURE__*/_jsx(LearnMore, {
      isDesktop: false,
      size: "7"
    })
  })]
}));
export default LandingMobile;